import type { WidgetProps } from './WidgetProps'
import { ScheduleTimeline } from './ScheduleTimeline'
import { EmptyHint } from './EmptyHint'

export function TodayScheduleWidget({ payload }: WidgetProps) {
  const lessons = Array.isArray(payload.lessons) ? payload.lessons : []

  if (lessons.length === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.today_schedule.empty" />
  }

  return <ScheduleTimeline lessons={lessons} />
}
